module.exports = __webpack_public_path__ + "media/images/shop/shop-cover-7bea31beb9c9b3e2a3d569e20028fca5.png";